  import React, { useState, useEffect, useRef } from 'react';
  import '../../css/DropdownComponent.css';
  import { useTranslations } from './TranslationContext';
  import { getCurrentUser } from '../../functions/utils.js'; // Import the utility function
  // Import the core library and icon packs you need
  import { library } from '@fortawesome/fontawesome-svg-core';
  import { faFilter, } from '@fortawesome/free-solid-svg-icons';
  import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
  // Add the icons you will use to the library
  library.add(faFilter);
  const DropdownComponent = ({ options, onSelect, defaultValue, className }) => {
    const { getTranslation, translations } = useTranslations();
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(() => {
      // Try to match defaultValue with options
      if (!defaultValue || !options) return null;
      return options.find(o => o.value === defaultValue.value) || null;
    });

    const [filteredOptions, setFilterOptions] = useState([]);
    const dropdownRef = useRef(null);
    const [defaultOption, setDefaultOption] = useState();
    const [currentUser, setCurrentUser] = useState([]);

    useEffect(() =>{  
      checkDevUser();
      if(options.length > 0 && options[0].type == "beginbalans"){
        setSelectedOption(defaultValue);
      }
      else if(options.length > 0 && options[0].type == "memoriaal"){
        setSelectedOption(defaultValue);
      }
    }, []);

    useEffect(() =>{
    }, [currentUser]);

    useEffect(() => {

    }, [filteredOptions, defaultValue]);
    
    useEffect(() => {
      setFilterOptions(options);
      if(options.length > 0 && (options[0].type == "administration" || options[0].type == "case" || options[0].type == "dataset")){
        setDefaultOption(defaultValue);
      }
      else if(options.length > 0 && options[0].type == "beginbalans"){
        setDefaultOption(defaultValue);
      }
      else if(options.length > 0 && options[0].type == "memoriaal"){
        setDefaultOption(defaultValue);
      }
    }, [options]);
    async function handleClickOutside(event) {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setIsOpen(false);
          closeDropdown();
        }
      }
    async function checkDevUser(){
      var currentUser = await getCurrentUser();
      if(currentUser){
        setCurrentUser(currentUser);
      }
      else{
        setTimeout(function(){
          return checkDevUser();
        }, 500);
      }
    }
    
    //Handles dropdown click event
    const handleOptionClick = (option) => {
      console.log(option);
      setSelectedOption(option);
      setIsOpen(false);
      onSelect(option);
      closeDropdown();
    };

    //Resets dropdown event
    const resetDropdown = () => {
      const defaultOpt = options.find(o => o.value === defaultValue.value) || null;
      setSelectedOption(defaultOpt);
    };

    async function handleFilter(event){
      var inputValue = event.target.value.toLowerCase(); // normalize case
      var filtered = options.filter(option =>
        option.label.toLowerCase().includes(inputValue)
      );
      setFilterOptions(filtered);
    }

    async function toggleDropdown(){
      var dropdownContainer = document.querySelector(`.${className}-dropdown`);
      var dropdownEl = dropdownContainer.querySelector(".dropdown-list-container");
      
      if(dropdownEl.classList.contains('visible')){
        document.removeEventListener('mousedown', handleClickOutside);
      }else{
        document.addEventListener('mousedown', handleClickOutside);
      }
      dropdownEl.classList.toggle("visible");

      

      setIsOpen(!isOpen);
    }
    
    async function closeDropdown(){
      document.removeEventListener('mousedown', handleClickOutside);
      var dropdownContainer = document.querySelector(`.${className}-dropdown`);
      var dropdownEl = dropdownContainer.querySelector(".dropdown-list-container");
      dropdownEl.classList.remove("visible");
    }
    return (
      <div className={`custom-dropdown ${className}-dropdown`} ref={dropdownRef}>
        <div className="dropdown-header"  value={selectedOption ? selectedOption.value : null} onClick={()=> {toggleDropdown();}}>
          {selectedOption ? selectedOption.label : getTranslation("import_SelectAnOption")}
          <span className={`arrow ${isOpen ? 'open' : ''}`}></span>
        </div>
          <div className='dropdown-list-container'>
            <div className="dropdown-list-content">
              <ul className="dropdown-list">
                {filteredOptions.map((option, index) => (
                  <li
                    key={index}
                    className={`dropdown-item ${selectedOption === option ? 'selected' : ''}`}
                    onClick={() => handleOptionClick(option)}
                    value={option.value}
                  >
                    {option.label} { option.value ? (options[0].type == "administration" || options[0].type == "case" || options[0].type == "dataset") ? null : null : null}
                  </li>     
                ))}
            
              </ul>    
              {/* {currentUser == 819 &&  ( */}
              <div className={`dropdown-filter`}>
                <div className="dropdown-filter-icon-container">
                  <FontAwesomeIcon className="dropdown-filter-icon" icon={faFilter}/>
                </div>
                      
                <input id="input-dropdwn-filter" placeholder="" onChange={(event) => handleFilter(event)}/>
              </div>
              {/* )} */}
            </div>
          </div>
  
          <span className="reset-dropdown-btn" onClick={() => resetDropdown()}></span>
        </div>
    );
  }

  export default DropdownComponent;
